import { Link, useLocation } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export default function Breadcrumbs({ items }) {
  const loc = useLocation();
  const crumbs = items || [
    { label: loc.pathname.replace("/", "").replace(/-/g, " ") || "Page", to: loc.pathname },
  ];
  return (
    <nav data-testid="breadcrumbs" className="text-xs text-slate-500 flex items-center gap-2 mb-6 capitalize">
      <Link to="/" className="inline-flex items-center gap-1 hover:text-brand"><Home size={12} /> Home</Link>
      {crumbs.map((c, i) => (
        <span key={i} className="inline-flex items-center gap-2">
          <ChevronRight size={12} />
          {i === crumbs.length - 1 ? (
            <span className="text-slate-700 font-medium">{c.label}</span>
          ) : (
            <Link to={c.to} className="hover:text-brand">{c.label}</Link>
          )}
        </span>
      ))}
    </nav>
  );
}
